import {
	ExcelFileExtension,
	FileExtension,
	PowerPointFileExtension,
	WordFileExtension,
} from "@inrev/common";
import { HiOutlineDocument } from "react-icons/hi2";
import { ValueOf } from "type-fest";

export const CustomFileIcon = ({ extension }: { extension: FileExtension }) => (
	<div className="relative w-fit h-fit shrink-0 select-none">
		<HiOutlineDocument className="text-[25px] text-gray-700" />
		{[
			FileExtension.pdf,
			...Object.values(WordFileExtension),
			...Object.values(ExcelFileExtension),
			...Object.values(PowerPointFileExtension),
		].includes(extension as unknown as any) && (
			<div
				className={`
                absolute top-[11px] left-[2px] right-[2px] flex items-center justify-center leading-[10px] h-[10px] text-inverse text-[10px] font-medium
                ${
									extension === FileExtension.pdf
										? "bg-red-500"
										: Object.values(WordFileExtension).includes(
													extension as ValueOf<typeof WordFileExtension>,
												)
											? "bg-blue-600"
											: Object.values(ExcelFileExtension).includes(
														extension as ValueOf<typeof ExcelFileExtension>,
													)
												? "bg-green-700"
												: Object.values(PowerPointFileExtension).includes(
															extension as ValueOf<typeof PowerPointFileExtension>,
														)
													? "bg-orange-500"
													: ""
								}
            `}
			>
				{extension}
			</div>
		)}
	</div>
);
